import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component, createRef } from 'react';
import Select from 'react-select';
import IconKMSImageIcon from '../../../assets/icons/IconKMSImageIcon';
import IconKMSUpload from '../../../assets/icons/IconKMSUpload';
import Alert from '../../../components/Alert/Alert';
import RadioTab from '../../../components/Radio/RadioTab';
import CreatableSelect from 'react-select/creatable';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import ActionType from '../../../redux/reducer/globalActionType';
import { connect } from 'react-redux';
import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import API_KMS from '../../../api/apiKMS';
import MasterDataUserAlert from '../../../components/MasterData/MasterDataUserAlert';
import { last } from 'lodash';
import MENU_KMS from '../../../constants/menuKMSConstant';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_KMS_UPDATE } from '../../../constants/menuPermissionConstant';

const validationTitle = MENU_KMS.validationTitle;
const validationUrlLink = MENU_KMS.validationUrlLink;

class KMSListEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kmsId: "",
            dataKMS: {
                categoryId: "",
                categoryName: "",
                title: "",
                description: "",
                type: { label: "", value: "" },
                urlLink: "",
                tags: [],
                imageFile: null,
                status: "",
                rating: 0,
                totalRate: 0,
                ratingRemark: []
            },
            updatedAt: "",
            typeOptionsList: [],
            tagOptionsList: [],
            errorMessage: "",
            showErrorAlertResponse: false,
            showPopupImage: false,
            showConfirmAlert: false,
            showSuccessAlert: false,
            showAlertTitle: false,
            showAlertTitleRegex: false,
            showAlertTitleMin: false,
            showAlertTitleMax: false,
            showAlertType: false,
            showAlertUrlLinkMax: false,
            showAlertUrlLinkRegex: false,
        }
        this.containerRef = createRef()
    }

    componentDidMount() {
        if (!this.props.history.location.state) {
            this.props.history.push(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY);
        }
        this.setState({
            kmsId: this.props.history.location.state.kmsId,
            typeOptionsList: this.getTypeOptions(this.props.history.location.state.categoryKMSDetail.type)
        })
        let kmsIdFromHistoryState = this.props.history.location.state.kmsId;
        this.getDetailKMS(kmsIdFromHistoryState);
        this.getTagOptionsList();
    }

    getDetailKMS = (kmsId) => {
        API_KMS.getDetailKMS(kmsId, this.props.token)
            .then(res => {
                let ratingRemark = getContent(res).rating_remark;
                let ratingRate = getContent(res).rating_rate;
                let rating = ratingRemark.map((remark, idx) => ({
                    remark,
                    rate: ratingRate[idx]
                }));

                this.setState({
                    dataKMS: {
                        categoryId: getContent(res).category_id,
                        categoryName: getContent(res).category,
                        title: getContent(res).title,
                        description: getContent(res).description,
                        type: this.getTypeFunction(getContent(res).type),
                        urlLink: getContent(res).url_link,
                        imageFile: getContent(res).picture_link,
                        tags: this.getTagsFunction(getContent(res).tags),
                        status: String(getContent(res).status),
                        rating: getContent(res).rating,
                        totalRate: getContent(res).total_rate,
                        ratingRemark: rating
                    },
                    updatedAt: getContent(res).updated_at,
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                if (err.response.data.nexsoft.payload.status.message === "Data id tidak diketahui") {
                    this.handleBackToKMSList();
                    setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                }
            }))
    }

    getTypeFunction = value => {
        switch (value) {
            case "C":
                return MENU_KMS.typeOptions[0];
            case "I":
                return MENU_KMS.typeOptions[1];
            case "B":
                return MENU_KMS.typeOptions[2];
            default:
                return { label: "", value: "" };
        }
    }

    getTagsFunction = value => {
        let processTags = [];
        if (value !== null) {
            processTags = value.map(
                obj => (Object.assign({ label: obj.description, value: obj.remark }))
            )
        }
        return processTags;
    }

    getTagOptionsList = () => {
        API_KMS.getTagOptionsList(this.props.token)
            .then(res => {
                this.setState({
                    tagOptionsList: getContent(res).map(
                        obj => (Object.assign({ label: obj.description, value: obj.remark }))
                    )
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.handleCancelKMSListAdd();
            }))
    }

    getTypeOptions = data => {
        let tempDataOptions = MENU_KMS.typeOptions;
        if (data.value === "C") {
            tempDataOptions =
                [
                    MENU_KMS.typeOptions[0],
                ]
        }
        if (data.value === "I") {
            tempDataOptions =
                [
                    MENU_KMS.typeOptions[1],
                ]
        }
        if (data.value === "B") {
            tempDataOptions = MENU_KMS.typeOptions;
        }
        return tempDataOptions;
    }

    getBooleanData = value => {
        if (value === "false") {
            return false;
        }
        return true;
    }

    handleChange = e => {
        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                [e.target.name]: e.target.value,
            }
        })
    }

    handleChangeType = data => {
        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                type: data
            }
        })
    }

    handleChangeTags = data => {
        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                tags: data
            }
        })
    }


    handleChangeAttachment = e => {
        let tempFile = e.target.files[0];

        if (!tempFile) {
            e.target.value = null;
            return
        }

        if (tempFile.type !== "image/jpeg" && tempFile.type !== "image/png" && tempFile.type !== "image/jpg") {
            e.target.value = null;
            return this.setState({
                errorMessage: "File yang dipilih bukan file gambar (JPEG, PNG & JPG). silahkan pilih file lain",
                showErrorAlertResponse: true
            });
        }

        if (tempFile.size / 1024 / 1024 >= 2) {
            e.target.value = null;
            return this.setState({
                errorMessage: `Maksimal Ukuran file 2Mb!`,
                showErrorAlertResponse: true
            });
        }

        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                imageFile: tempFile,
            }
        });
    }

    handleCheck = e => {
        this.setState({
            dataKMS: {
                ...this.state.dataKMS,
                [e.target.name]: e.target.value,
            }
        })
    }

    handleCategoryKMSMenu = () => {
        const getIdFromHistoryState = this.props.history.location.state.categoryKMSDetail.id;
        this.props.history.push(`/settings/kms/category/detail/${getIdFromHistoryState}`);
    }

    handleBackToKMSList = () => {
        const getCategoryKMSDetailFromHistoryState = this.props.history.location.state.categoryKMSDetail;
        this.props.history.goBack();
        this.props.history.push({ state: { categoryKMSDetail: getCategoryKMSDetailFromHistoryState } });
    }

    handleSave = () => {
        if (this.handleValidationField()) {
            return this.containerRef.current.scrollIntoView({ behavior: 'smooth' })
        }
        this.setState({ showConfirmAlert: true })
    }

    handleValidationField = () => {
        let isFieldError = false;
        this.setState({
            showAlertTitle: false,
            showAlertTitleRegex: false,
            showAlertType: false,
            showAlertTitleMin: false,
            showAlertTitleMax: false,
            showAlertUrlLinkMax: false,
            showAlertUrlLinkRegex: false,
        })

        if (this.state.dataKMS.title !== "" && this.state.dataKMS.title.length < 5) {
            this.setState({ showAlertTitleMin: true })
            isFieldError = true;
        }

        if (this.state.dataKMS.title !== "" && this.state.dataKMS.title.length > 50) {
            this.setState({ showAlertTitleMax: true })
            isFieldError = true;
        }

        if (!validationTitle.test(this.state.dataKMS.title)) {
            this.setState({ showAlertTitleRegex: true })
            isFieldError = true;
        }

        if (this.state.dataKMS.title === "") {
            this.setState({ showAlertTitle: true })
            isFieldError = true;
        }

        if (this.state.dataKMS.type.value === "") {
            this.setState({ showAlertType: true })
            isFieldError = true;
        }

        if (this.state.dataKMS.urlLink !== "" && this.state.dataKMS.urlLink.length > 256) {
            this.setState({ showAlertUrlLinkMax: true })
            isFieldError = true;
        }

        if (this.state.dataKMS.urlLink !== "" && !validationUrlLink.test(this.state.dataKMS.urlLink.trim())) {
            this.setState({ showAlertUrlLinkRegex: true })
            isFieldError = true;
        }

        return isFieldError;
    }

    handleEditKMS = () => {
        this.setState({ showConfirmAlert: false });
        let bodyFormData = new FormData();

        const data = {
            category_id: this.state.dataKMS.categoryId,
            title: this.state.dataKMS.title,
            description: this.state.dataKMS.description,
            type: this.state.dataKMS.type.value,
            url_link: this.state.dataKMS.urlLink.trim(),
            status: this.getBooleanData(this.state.dataKMS.status),
            tags: this.state.dataKMS.tags.map(data => { return data.value }),
            delete_foto: this.state.dataKMS.imageFile ? false : true,
            updated_at: this.state.updatedAt
        }

        bodyFormData.append('photo1', this.state.dataKMS.imageFile);
        bodyFormData.append('content', JSON.stringify(data));

        API_KMS.putDataEditKMS(this.state.kmsId, bodyFormData, this.props.token)
            .then(res => {
                this.setState({
                    showConfirmAlert: false,
                    showSuccessAlert: true,
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    successEditKMS = () => {
        this.setState({ showSuccessAlert: false });
        this.handleBackToKMSList();
    }

    getFilenameFromUrl = value => {
        if (value) {
            return last(value.split("/"));
        }
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_KMS_UPDATE]} userPermission={this.props.userDetail.permissions}>
                <div ref={this.containerRef} className="space-y-3">
                    <BreadCrumbs
                        parentMenu="Pengaturan"
                        serviceMenu="KMS"
                        menuItem="Edit Daftar KMS"
                        title="Knowledge Management Sistem"
                    />

                    {/* WHITECONTAINER */}
                    <div className="white-container pb-24">
                        <div className="w-full bg-white border border-gray-300 rounded-lg p-8">
                            {/* MENU HEADBAR */}
                            <div className="flex items-center space-x-5 text-2xl text-gray-700 pb-10">
                                <button className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY) ? "active-menu-kms font-medium" : "font-medium"} onClick={this.handleCategoryKMSMenu}>
                                    Kategori KMS
                                </button>
                                <button className={`
                                    ${window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS_LIST) ? "active-menu-kms font-medium" : "font-medium"}
                                    "cursor-pointer"
                                `}
                                >
                                    Daftar KMS
                                </button>
                            </div>
                            {/* CONTENT */}
                            <div className="relative">
                                {/* Form */}
                                <div className="space-x-20 flex">
                                    {/* Right */}
                                    <div className="space-y-4 flex-initial w-3/12">
                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Kategori</p>
                                            </div>
                                            <input
                                                type="text"
                                                name="categoryName"
                                                className="form-control w-full"
                                                value={this.state.dataKMS.categoryName}
                                                onChange={this.handleChange}
                                                disabled
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Judul</p>
                                                <span className="text-darkred">*</span>
                                            </div>
                                            <input
                                                id="tsltitle"
                                                type="text"
                                                name="title"
                                                placeholder="Tulis Judul"
                                                className="form-control w-full"
                                                value={this.state.dataKMS.title}
                                                onChange={this.handleChange}
                                                minLength={5}
                                                maxLength={50}
                                            />
                                            {this.state.showAlertTitle && <MasterDataUserAlert text="Judul tidak boleh kosong!" />}
                                            {this.state.showAlertTitleRegex && <MasterDataUserAlert text="Judul hanya boleh mengandung spesial karakter ?" />}
                                            {this.state.showAlertTitleMin && <MasterDataUserAlert text="Jumlah karakter harus lebih besar dari 5" />}
                                            {this.state.showAlertTitleMax && <MasterDataUserAlert text="Jumlah karakter harus lebih kecil dari 50" />}
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Deskripsi</p>
                                            </div>
                                            <textarea
                                                id="tsldescription"
                                                type="textarea"
                                                name="description"
                                                placeholder="Tulis Deskripsi"
                                                value={this.state.dataKMS.description}
                                                onChange={this.handleChange}
                                                className="form-control w-full resize-none h-60"
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Tipe</p>
                                                <span className="text-darkred">*</span>
                                            </div>
                                            <Select
                                                inputId="ddltype"
                                                name="type"
                                                options={this.state.typeOptionsList}
                                                placeholder="Pilih Tipe"
                                                components={{ IndicatorSeparator: () => null }}
                                                className="w-full"
                                                maxMenuHeight={170}
                                                value={this.state.dataKMS.type}
                                                onChange={this.handleChangeType}
                                            />
                                            {this.state.showAlertType && <MasterDataUserAlert text="Tipe tidak boleh kosong!" />}
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Gambar</p>
                                            </div>
                                            {!this.state.dataKMS.imageFile ?
                                                <div className="flex justify-center items-center outline-none border-2 border-gray-300 border-dashed p-5 focus:outline-none">
                                                    <div className="flex flex-col items-center w-full relative space-y-2 text-center text-gray-600">
                                                        <IconKMSUpload />
                                                        <p className="font-bold text-xl">Tarik dan letakkan gambar disini</p>
                                                        <p className="">Jenis file : JPG</p>
                                                        <p className="font-semibold">Atau</p>
                                                        <button className="bg-olddarkblue text-white px-2 py-1 rounded-lg font-medium">Cari File</button>
                                                        <input id="btnattachfile" type="file" className="w-full h-full absolute top-0 left-0 opacity-0" accept="image/png, image/jpg, image/jpeg" onChange={this.handleChangeAttachment} />
                                                    </div>
                                                </div>
                                                :
                                                <div className="flex justify-between p-2 rounded-lg shadow-box-button bg-gray-100 text-gray-600">
                                                    <div className="flex items-center">
                                                        <div className="mr-2">
                                                            <IconKMSImageIcon />
                                                        </div>
                                                        <div className="w-52">
                                                            {(typeof this.state.dataKMS.imageFile) !== "string" ?
                                                                <>
                                                                    <p className="text-lg truncate" title={this.state.dataKMS.imageFile.name}>{this.state.dataKMS.imageFile.name}</p>
                                                                    <p className="text-sm">{Math.round(this.state.dataKMS.imageFile.size / 1024 / 1024 * 100) / 100} MB</p>
                                                                </>
                                                                :
                                                                <>
                                                                    <p className="text-lg truncate" title={this.getFilenameFromUrl(this.state.dataKMS.imageFile)}>{this.getFilenameFromUrl(this.state.dataKMS.imageFile)}</p>
                                                                </>
                                                            }
                                                            <p id="btnviewpicture" className="cursor-pointer text-blue-500" onClick={() => this.setState({ showPopupImage: true })}>Lihat Icon</p>
                                                        </div>
                                                    </div>
                                                    <div className="flex justify-end mt-1 mr-3">
                                                        <FontAwesomeIcon icon={faTimes} className="text-2xl cursor-pointer" onClick={() => { this.setState({ dataKMS: { ...this.state.dataKMS, imageFile: null } }) }} />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    {/* Left */}
                                    <div className="space-y-4 flex-initial w-3/12">
                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Link URL</p>
                                            </div>
                                            <input
                                                id="tslurllink"
                                                type="text"
                                                name="urlLink"
                                                placeholder="Tulis Link Url"
                                                value={this.state.dataKMS.urlLink}
                                                onChange={this.handleChange}
                                                className="form-control w-full"
                                                maxLength={256}
                                            />
                                            {this.state.showAlertUrlLinkRegex && <MasterDataUserAlert text="Url harus mengandung format http:// atau https://" />}
                                            {this.state.showAlertUrlLinkMax && <MasterDataUserAlert text="Jumlah karakter harus lebih kecil dari 256" />}
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Tag</p>
                                            </div>
                                            <CreatableSelect
                                                inputId="tsltag"
                                                name="tags"
                                                placeholder="Tulis Tag"
                                                options={this.state.tagOptionsList}
                                                components={{ IndicatorSeparator: () => null, DropdownIndicator: () => null }}
                                                className="w-full"
                                                maxMenuHeight={170}
                                                value={this.state.dataKMS.tags}
                                                onChange={this.handleChangeTags}
                                                isMulti
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Status</p>
                                            </div>
                                            <RadioTab id="tglstatus" radioInputName="status" dataOption={MENU_KMS.dataStatus} defaultCheck={this.state.dataKMS.status} onChange={this.handleCheck} />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Ulasan Pengguna</p>
                                            </div>
                                            <div className={`${this.state.dataKMS.rating > 50 || this.state.dataKMS.totalRate === 0 ? 'bg-lightlimegreen border border-darklimegreen' : 'bg-red-100 border border-red-200'} w-1/2 rounded-xl text-center px-2 py-1 flex justify-center items-center`}>
                                                <p className={this.state.dataKMS.rating > 50 || this.state.dataKMS.totalRate === 0 ? 'text-limegreen font-medium' : 'text-red-500 font-medium'}>{this.state.dataKMS.rating}%</p>
                                                <p className="text-gray-600 ml-1">({this.state.dataKMS.totalRate} Ulasan)</p>
                                            </div>
                                            {
                                                this.state.dataKMS.ratingRemark.map((rating, idx) =>
                                                    <div key={idx}>
                                                        <p className="text-sm">{rating.remark}</p>
                                                        <div className="flex items-center relative">
                                                            <div className="w-full bg-gray-300 rounded-full h-2.5">
                                                                <div className="bg-lightblue h-2.5 rounded-full" style={{ width: `${this.state.dataKMS.totalRate === 0 ? 0 : (100 * rating.rate) / this.state.dataKMS.totalRate}%` }}></div>
                                                            </div>
                                                            <p className="absolute -right-20 pl-1 text-sm">{rating.rate} Ulasan</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>

                                {/* Button */}
                                <div className="flex space-x-5 absolute -bottom-24 -right-8">
                                    <button className="border border-olddarkblue bg-transparent text-olddarkblue py-2 px-6 rounded-lg font-medium" onClick={this.handleBackToKMSList}>Batal</button>
                                    <button className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={this.handleSave}>Simpan</button>
                                </div>

                                {/* Popup Modal Image */}
                                <div className={this.state.showPopupImage ? "block" : "hidden"}>
                                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                                        <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none w-5/12 min-w-min">
                                            <div className="body-attachment w-full flex rounded-lg flex-col p-8 font-bold text-lg space-y-5">
                                                <div>
                                                    {(typeof this.state.dataKMS.imageFile) !== "string" ?
                                                        <div className="text-2xl">{this.state.dataKMS.imageFile ? this.state.dataKMS.imageFile.name : ""}</div>
                                                        :
                                                        <div className="text-2xl">{this.state.dataKMS.imageFile && this.getFilenameFromUrl(this.state.dataKMS.imageFile)}</div>
                                                    }
                                                </div>
                                                <div className="flex justify-center items-center">
                                                    {(typeof this.state.dataKMS.imageFile) !== "string" ?
                                                        <img src={this.state.dataKMS.imageFile && URL.createObjectURL(this.state.dataKMS.imageFile)} alt={this.state.dataKMS.imageFile ? this.state.dataKMS.imageFile.name : ""} className="h-96" />
                                                        :
                                                        <img src={this.state.dataKMS.imageFile && this.state.dataKMS.imageFile} alt={"File"} className="h-96" />
                                                    }
                                                </div>
                                                <div className="flex justify-center items-center">
                                                    <button id="btncloseviewicon" className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={() => this.setState({ showPopupImage: false })}>Tutup</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                </div>

                                {/* Alert */}
                                <Alert show={this.state.showConfirmAlert} button={true} title="Mengubah KMS?" desc={"Data otomatis akan tersimpan di KMS"} close={() => this.setState({ showConfirmAlert: false })} submit={this.handleEditKMS} />
                                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc={"Data berhasil disimpan!"} close={this.successEditKMS} ok />
                                <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                            </div>
                        </div>
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KMSListEdit);